import { useState } from 'react';
import { toast } from 'react-toastify';
import { Box, Button, Card, CardBody, Form, Layer } from 'grommet';
import { ApiError } from '/src/api';
import { CardHeader, Input } from '/src/components';
import { toastMessages } from '/src/lib/toast';

interface StripeAccount {
  id: string;
  contact_email: string;
}

interface EditRecipientModalProps {
  isVisible: boolean;
  setIsVisible: (visible: boolean) => void;
  selectedAccount: StripeAccount | null;
  onRecipientUpdated: () => void;
}

export const EditRecipientModal = ({
  isVisible,
  setIsVisible,
  selectedAccount,
  onRecipientUpdated,
}: EditRecipientModalProps) => {
  const [email, setEmail] = useState(selectedAccount?.contact_email || '');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!selectedAccount) return;

    try {
      setLoading(true);
      toast.success(toastMessages.updateStripeRecipient.success);
      onRecipientUpdated();
      setIsVisible(false);
    } catch (error) {
      console.error('Error updating recipient:', error);
      toast.error(toastMessages.updateStripeRecipient.error(error as ApiError));
    } finally {
      setLoading(false);
    }
  };

  if (!isVisible || !selectedAccount) return null;

  return (
    <Layer
      onEsc={() => setIsVisible(false)}
      onClickOutside={() => setIsVisible(false)}
      position="center"
      modal
      background="transparent"
    >
      <Card width="100%" style={{ maxWidth: 480, minWidth: 320 }}>
        <CardHeader title="Edit Email" />
        <CardBody pad={{ vertical: 'medium', horizontal: 'large' }}>
          <Box gap="medium">
            <Form onSubmit={handleSubmit}>
              <Box margin={{ bottom: 'small' }}>
                <Input
                  label="Email"
                  value={email}
                  setValue={setEmail}
                  placeholder="Enter email"
                  type="email"
                  required
                  style={{ width: '100%' }}
                  margin={{ bottom: 'small' }}
                />
              </Box>

              <Box direction="row" gap="small" justify="end">
                <Button
                  label="Cancel"
                  onClick={() => setIsVisible(false)}
                  disabled={loading}
                  style={{ fontWeight: 'normal' }}
                />
                <Button primary label="Save" type="submit" disabled={loading} style={{ fontWeight: 'normal' }} />
              </Box>
            </Form>
          </Box>
        </CardBody>
      </Card>
    </Layer>
  );
};
